import car from '../../lib/car';
import animate from 'widgets/functions/animation/animate';
import enterAnimate from 'widgets/functions/enter-effects/enter-animate';
import roomLib from '../room';

const enter = (socketEvent) => {
  // getStore().messages.add({
  //   msg: {
  //     "action": "room.change",
  //     "data_d": {
  //       "enter_info": "",
  //       "tuid": 30108585,
  //       "pic": "http://test.img.sumeme.com/23/7/1516764526295.jpg",
  //       "mm_no": 20884035,
  //       "qd": "meme_default",
  //       "mobile_bind": true,
  //       "guild_name": "Xxxx",
  //       "nick_name": "9527",
  //       "spend": 14315774,
  //       "guild_id": 10219,
  //       "_id": 20884035,
  //       "priv": 3,
  //       "guild_identity": 3,
  //       "timestamp": 1585879247101,
  //       "platform": 1,
  //       "is_curr_room_star": false,
  //       "room_id": 1201389,
  //       "medal_list": [],
  //       "guard": 0,
  //       "is_guard": false,
  //       "is_shutup": false,
  //       "shutup_end_time": 0,
  //       "device": "pc",
  //       "s": "pc",
  //       "is_mobile": true,
  //       "is_nearby": false,
  //       "is_disable_verify": false,
  //       "ip": "192.168.31.10",
  //       "is_48_hr_new_user": false,
  //       "is_24_hr_new_user": false
  //     }
  //   },
  //   msgType: 'enter'
  // })

  socketEvent.on('room.change_no_login', (msg, {}, { messages }) => {
    messages.add({
      msg,
      msgType: 'enterNoLogin',
    });
  });
  socketEvent.on('room.change', (msg, {}, { messages }) => {
    let { data_d: data } = msg;
    // 客服，运营，和机器人不显示进场信息
    if (data.priv === 4 || data._id <= 1024000) {
      return;
    }

    data.isMicStar = roomLib.isMicStar(data._id);

    data.car = data.guard_car || data.car;

    // data.car = 160

    // 如果有坐骑则显示动画
    if (data.car) {
      // console.log('room.change car',data.car)
      data.car = car.getCar(data.car);
      // console.log('room.change',data)
      if (data.car && !car.isEntered(data._id) && data.vip_hiding !== 1) {
        car.addEnter(data._id);
        animate.push(data);
      }
    }

    if (data.decorator?.car) {
      const allDecorators = window['MM_DECORATOR'] || [];
      const car = allDecorators.find((item) => data.decorator.car == item._id);
      if (car) {
        enterAnimate.push(data);
      }
    }

    messages.add({
      msg,
      msgType: 'enter',
    });
  });
};

export default enter;
